import { render, staticRenderFns } from "./CombinenowRootComponent.vue?vue&type=template&id=39dcc13e&scoped=true"
import script from "./CombinenowRootComponent.vue?vue&type=script&lang=js"
export * from "./CombinenowRootComponent.vue?vue&type=script&lang=js"
import style0 from "./CombinenowRootComponent.vue?vue&type=style&index=0&id=39dcc13e&prod&lang=css"
import style1 from "./CombinenowRootComponent.vue?vue&type=style&index=1&id=39dcc13e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dcc13e",
  null
  
)

export default component.exports